import React from "react";
import { forwardRefAs, Generic } from "../../base";
export const TableBody = forwardRefAs((props, ref) => React.createElement(Generic, Object.assign({ ref: ref }, props)), { as: "tbody" });
TableBody.displayName = "Table.Body";
//# sourceMappingURL=table-body.js.map